import { useState } from "react";
import {
    Box,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    IconButton,
    Tooltip,
    Modal,
    CircularProgress,
    Typography
} from "@mui/material";

import { Texto, buttonGuardar, Input, buttonCancelar, modalStyle } from "../../Layouts/CustomStyles";
import { DataGrid } from "@mui/x-data-grid";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { DiseñoDataGrid } from "../FuncionesGenerales/DataGrid";
import { FaTrashCan } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";

import { Loading } from "../../Utils/Loading";
import { useIngresoINMOB } from "../../Services/Inmobiliaria/Ingresos";
import { useIngresoTodosINMOB } from "../../Hook/Inmobiliaria/Ingresos";

export const ContactoIngresoINMOB = () => {

    const {
        contactos,
        loadingContactos,
        refetchContactos: fetchContactos
    } = useIngresoTodosINMOB();

    const {
        crearContactoInmobiliaria,
        editarContactoInmobiliaria,
        eliminarContactoInmobiliaria
    } = useIngresoINMOB();

    const [openDialog, setOpenDialog] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);

    const [form, setForm] = useState({
        nombre: "",
        rut:"",
        telefono: "",
        email: ""
    });

    const [editando, setEditando] = useState(null);
    const [selected, setSelected] = useState(null);

    const [successAlertOpen, setSuccessAlertOpen] = useState(false);
    const [errorAlertOpen, setErrorAlertOpen] = useState(false);
    const [enviandoAlert, setEnviandoAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    // CREATE
    const handleCrear = () => {
        setEditando(null);
        setForm({ nombre: "", rut:"", telefono: "", email: "" });
        setOpenDialog(true);
    };

    // EDIT
    const handleEditar = (row) => {
        setEditando(row);
        setForm(row);
        setOpenDialog(true);
    };

    // SAVE (BACKEND)
    const handleGuardar = async () => {
        try {
            setEnviandoAlert(true);

            if (editando) {
                await editarContactoInmobiliaria(editando.id, form);
                setAlertMessage("Contacto actualizado");
            } else {
                await crearContactoInmobiliaria(form);
                setAlertMessage("Contacto creado");
            }

            setSuccessAlertOpen(true);
            setOpenDialog(false);
            setForm({ nombre: "", telefono: "", email: "" });
            setEditando(null);

            fetchContactos();

        } catch (error) {
            setErrorAlertOpen(true);
            setAlertMessage(error);
        } finally {
            setEnviandoAlert(false);
        }
    };

    // DELETE
    const handleEliminar = (row) => {
        setSelected(row);
        setOpenDeleteModal(true);
    };

    const confirmarEliminar = async () => {
        try {
            setEnviandoAlert(true);

            await eliminarContactoInmobiliaria(selected.id);

            setAlertMessage("Contacto eliminado");
            setSuccessAlertOpen(true);

            fetchContactos();

        } catch (error) {
            setErrorAlertOpen(true);
            setAlertMessage(error);
        } finally {
            setEnviandoAlert(false);
            setOpenDeleteModal(false);
            setSelected(null);
        }
    };

    const columns = [
        { field: "nombre", headerName: "Nombre", flex: 1 },
        { field: "rut", headerName: "rut", flex: 1 },
        { field: "telefono", headerName: "Teléfono", flex: 1 },
        { field: "email", headerName: "Email", flex: 1 },

        {
            field: "acciones",
            headerName: "Acciones",
            width: 150,
            
              renderCell: (params) => {
                            return (
                                <Box
                                    sx={{
                                        display: "flex",
                                        gap: 1,
                                        width: 150,
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <button className="edit-button" onClick={() => handleEditar(params.row)}>
                                        <svg className="edit-svgIcon" viewBox="0 0 512 512">
                                            <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32z" />
                                        </svg>
                                    </button>
                                    <button className="delete-button" onClick={() => handleEliminar(params.row)}>
                                        <FaTrashCan className="delete-svgIcon" />
                                    </button>
                                </Box>
                            );
                        },

        
        }
    ];

    if (loadingContactos) return <Loading />;

    return (
        <Box>

            {/* CREATE */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                <Tooltip title="Crear contacto">
                    <IconButton onClick={handleCrear}>
                        <AddCircleIcon />
                    </IconButton>
                </Tooltip>
            </Box>

            {/* GRID */}
            <DataGrid
                rows={contactos}
                columns={columns}
                getRowId={(row) => row.id}
                slots={{ noRowsOverlay: DiseñoDataGrid }}
            />

            {/* FORM */}
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                <DialogTitle sx={Texto}>
                    {editando ? "Editar contacto" : "Crear contacto"}
                </DialogTitle>

                <DialogContent>
                    <TextField
                        fullWidth
                        label="Nombre"
                        value={form.nombre}
                        onChange={(e) => setForm({ ...form, nombre: e.target.value })}
                        sx={{...Input,mt:2}}
                    />
                     <TextField
                        fullWidth
                        label="Rut"
                        value={form.rut}
                        onChange={(e) => setForm({ ...form, rut: e.target.value })}
                        sx={{...Input,mt:2}}
                    />

                    <TextField
                        fullWidth
                        label="Teléfono"
                        value={form.telefono}
                        onChange={(e) => setForm({ ...form, telefono: e.target.value })}
                         sx={{...Input,mt:2}}
                    />

                    <TextField
                        fullWidth
                        label="Email"
                        value={form.email}
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                         sx={{...Input,mt:2}}
                    />
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)} sx={buttonCancelar}>
                        Cancelar
                    </Button>
                    <Button onClick={handleGuardar} sx={buttonGuardar}>
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>

            {/* DELETE */}
            <Dialog open={openDeleteModal} onClose={() => setOpenDeleteModal(false)}>
                <DialogTitle sx={Texto}>Confirmar eliminación</DialogTitle>

                <DialogContent>
                    <Typography>
                        ¿Eliminar contacto <b>{selected?.nombre}</b>?
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenDeleteModal(false)}>
                        Cancelar
                    </Button>

                    <Button onClick={confirmarEliminar} color="error">
                        Eliminar
                    </Button>
                </DialogActions>
            </Dialog>

             <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                            <Box sx={modalStyle}>
                                <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                                    <IoClose />
                                </section>
                                <section style={{ textAlign: "center" }}>
                                    <FaRegCircleCheck style={{ color: "green", fontSize: "2rem" }} />
                                    <p className="alert-text">{alertMessage}</p>
                                </section>
                            </Box>
                        </Modal>
            
                        <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                            <Box sx={modalStyle}>
                                <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                                    <IoClose />
                                </section>
                                <section style={{ textAlign: "center" }}>
                                    <BiErrorCircle style={{ color: "red", fontSize: "2rem" }} />
                                    <p className="alert-text">{alertMessage}</p>
                                </section>
                            </Box>
                        </Modal>
            
                        <Modal open={enviandoAlert}>
                            <Box sx={modalStyle}>
                                <section style={{ textAlign: "center", padding: "1rem" }}>
                                    <CircularProgress style={{ color: "#2a8d74" }} />
                                    <p className="alert-text">Procesando solicitud...</p>
                                </section>
                            </Box>
                        </Modal>

        </Box>
    );
};